<template>
  <body :class="classes">
    <router-view />

    <div v-if="$store.state.modal.isShow" class="modal-base">
      <component :is="$store.state.modal.target" />
    </div>
  </body>
</template>

<script>
  export default {
    name: 'App',
    components: {
      ModalConnectWallet: () => import('@/components/molecules/ModalConnectWallet'),
      AccountWalletModal: () => import('@/components/organisms/account/AccountWalletModal'),
      SteamClaimModal: () => import('@/components/organisms/steam/SteamClaimModal')
    },
    computed: {
      classes() {
        return [`theme--${this.$store.state.theme}`, { 'is-modal' : this.$store.state.modal.isShow }]
      }
    }
  }

</script>

<style lang="scss">
  @import '@/assets/scss/style.scss';

  .theme--light {
    @each $item in $colors-array {
      --#{$item}: #{map-get($light-theme, #{$item})};
    }
  }

  .theme--dark {
    @each $item in $colors-array {
      --#{$item}: #{map-get($dark-theme, #{$item})};
    }
  }
  html{
    scroll-behavior: smooth;
  }
  body {
    background: var(--color_bg);
    color: var(--color_font);
    &.is-modal {
      overflow: hidden;
    }
  }

  .modal-base {
    background: var(--color_bg_modal);
    position: fixed;
    width: 100vw;
    height: 100vh;
    left: 0;
    top: 0;
  }
</style>